var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { html } from 'lit';
import { property } from 'lit/decorators.js';
import { ifDefined } from 'lit/directives/if-defined.js';
import { BlocksElement } from '../../BlocksElement';
import styles from '../icon.styles';
/**
 * CalendarClock component
 * @csspart base- The component's base wrapper
 */
export class BlocksIconCalendarClock extends BlocksElement {
    static { this.styles = styles; }
    connectedCallback() {
        super.connectedCallback();
        this.classList.add('cat-icon');
    }
    render() {
        const componentClassName = this.componentClassNames('cat-c-icon', {
            'cat-c-icon--sm': this.size === 'sm',
            'cat-c-icon--lg': this.size === 'lg',
            'cat-c-icon--xl': this.size === 'xl',
            'cat-c-icon--content-strong': this.color === 'content-strong',
            'cat-c-icon--knockout': this.color === 'knockout',
            'cat-c-icon--knockout-brand': this.color === 'knockout-brand',
            'cat-c-icon--information': this.color === 'information',
            'cat-c-icon--success': this.color === 'success',
            'cat-c-icon--warning': this.color === 'warning',
            'cat-c-icon--error': this.color === 'error'
        });
        return html `
      <span part="base" class="${componentClassName}" role="presentation">
        <svg
          aria-hidden="${!this.iconTitle}"
          aria-label="${ifDefined(this.iconTitle)}"
          role="${this.iconTitle && 'img'}"
          width="24"
          height="24"
          viewBox="0 0 24 24"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M9.55 18.38H3.09C2.94 18.38 2.78 18.32 2.67 18.21C2.56 18.1 2.5 17.95 2.5 17.8V9.19H18.38V9.55C18.38 9.96 18.72 10.3 19.13 10.3C19.54 10.3 19.88 9.96 19.88 9.55V5.09C19.88 4.53 19.66 4.01 19.27 3.61C18.87 3.22 18.35 3 17.79 3H15.87V1.75C15.87 1.34 15.53 1 15.12 1C14.71 1 14.37 1.34 14.37 1.75V3.01H6.51V1.75C6.51 1.34 6.17 1 5.76 1C5.35 1 5.01 1.34 5.01 1.75V3.01H3.09C2.54 3.01 2 3.23 1.61 3.62C1.22 4.01 1 4.54 1 5.1V17.8C1 18.35 1.22 18.89 1.61 19.28C2 19.67 2.54 19.89 3.09 19.89H9.55C9.96 19.89 10.3 19.55 10.3 19.14C10.3 18.73 9.96 18.39 9.55 18.39V18.38ZM2.5 5.09C2.5 4.93 2.56 4.79 2.67 4.67C2.78 4.55 2.93 4.5 3.09 4.5H5.01V5.76C5.01 6.17 5.35 6.51 5.76 6.51C6.17 6.51 6.51 6.17 6.51 5.76V4.5H14.37V5.76C14.37 6.17 14.71 6.51 15.12 6.51C15.53 6.51 15.87 6.17 15.87 5.76V4.5H17.79C17.95 4.5 18.09 4.56 18.21 4.67C18.32 4.78 18.38 4.93 18.38 5.09V7.68H2.5V5.09ZM17.3301 11.8701C14.3101 11.8701 11.8701 14.3201 11.8701 17.3301C11.8701 20.3401 14.3201 22.7901 17.3301 22.7901C20.3401 22.7901 22.7901 20.3401 22.7901 17.3301C22.7901 14.3201 20.3401 11.8701 17.3301 11.8701ZM17.3301 21.3001C15.1401 21.3001 13.3701 19.5301 13.3701 17.3401C13.3701 15.1501 15.1401 13.3801 17.3301 13.3801C19.5201 13.3801 21.2901 15.1501 21.2901 17.3401C21.2901 19.5301 19.5201 21.3001 17.3301 21.3001ZM16.7898 16.8001L17.9698 15.6201C18.2598 15.3301 18.7398 15.3301 19.0298 15.6201C19.3198 15.9101 19.3198 16.3901 19.0298 16.6801L17.8498 17.8601C17.5598 18.1501 17.0798 18.1501 16.7898 17.8601C16.4998 17.5701 16.4998 17.0901 16.7898 16.8001Z"
          />
        </svg>
      </span>
    `;
    }
}
__decorate([
    property({ type: String })
], BlocksIconCalendarClock.prototype, "color", void 0);
__decorate([
    property({ type: String })
], BlocksIconCalendarClock.prototype, "iconTitle", void 0);
__decorate([
    property({ type: String })
], BlocksIconCalendarClock.prototype, "size", void 0);
if (customElements.get('cat-icon-calendar-clock') === undefined) {
    customElements.define('cat-icon-calendar-clock', BlocksIconCalendarClock);
}
